(() => {
  'use strict';

  document.documentElement.classList.remove('no-js');

  const closeDialog = (dialog) => {
    if (dialog && dialog.open) dialog.close();
  };

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.querySelectorAll('.dialog-close').forEach((button) => {
      button.addEventListener('click', () => closeDialog(dialog));
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
  });

  const mobileMenu = document.querySelector('#MobileMenu');
  const searchDialog = document.querySelector('#SiteSearch');

  document.querySelector('.menu-trigger')?.addEventListener('click', () => mobileMenu?.showModal());

  const navGroups = [...document.querySelectorAll('[data-nav-group]')];
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const setExpanded = (details) => {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  };
  const closeNavGroups = (except) => {
    navGroups.forEach((details) => {
      if (details !== except && details.open) {
        details.removeAttribute('open');
        setExpanded(details);
      }
    });
  };
  navGroups.forEach((details) => {
    const summary = details.querySelector('summary');
    let leaveTimer;
    details.addEventListener('mouseenter', () => {
      if (!finePointer.matches) return;
      clearTimeout(leaveTimer);
      closeNavGroups(details);
      details.open = true;
      setExpanded(details);
    });
    details.addEventListener('mouseleave', () => {
      if (!finePointer.matches) return;
      clearTimeout(leaveTimer);
      leaveTimer = window.setTimeout(() => {
        if (details.contains(document.activeElement)) return;
        details.open = false;
        setExpanded(details);
      }, 150);
    });
    details.addEventListener('toggle', () => setExpanded(details));
    details.addEventListener('focusout', (event) => {
      if (details.contains(event.relatedTarget) || (finePointer.matches && details.matches(':hover'))) return;
      details.removeAttribute('open');
      setExpanded(details);
    });
    summary?.addEventListener('click', (event) => {
      if (finePointer.matches && event.detail > 0) {
        event.preventDefault();
        return;
      }
      requestAnimationFrame(() => {
        if (details.open) closeNavGroups(details);
        setExpanded(details);
      });
    });

  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-nav-group]')) closeNavGroups();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const activeGroup = document.activeElement?.closest('[data-nav-group]');
      if (activeGroup?.open) activeGroup.querySelector('summary')?.focus();
      closeNavGroups();
    }
  });
  const openSiteSearch = (preset) => {
    closeDialog(mobileMenu);
    searchDialog?.showModal();
    requestAnimationFrame(() => {
      const input = document.querySelector('#site-search');
      if (!input) return;
      if (preset) {
        input.value = preset;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      input.focus();
    });
  };
  document.querySelectorAll('.search-trigger').forEach((button) => {
    button.addEventListener('click', () => openSiteSearch());
  });
  const selectCardVariant = (choice) => {
    const card = choice.closest('.catalog-card');
    if (!card) return;
    const id = choice.dataset.cardVariant;
    const url = choice.dataset.cardUrl;
    if (!id || !url) return;
    card.querySelectorAll('[data-card-variant]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === choice));
    });
    card.dataset.color = choice.dataset.cardColor || '';
    card.dataset.price = choice.dataset.cardPriceRaw || '';
    const colorLabel = card.querySelector('[data-card-color-label]');
    if (colorLabel) colorLabel.textContent = choice.dataset.cardColor || '';
    else if (card.dataset.rfEnhanced === '1') {
      const spec = card.querySelector('.catalog-card__spec');
      if (spec) spec.textContent = [card.dataset.pieces ? card.dataset.pieces + ' parça' : '', card.dataset.material, choice.dataset.cardColor].filter(Boolean).join(' · ');
    }
    card.querySelectorAll('.catalog-card__link, [data-card-title-link], .rf-product-action--view, .rf-product-action--add[href]').forEach((link) => {
      link.href = url;
    });
    card.querySelectorAll('form input[name="id"]').forEach((input) => {
      input.value = id;
    });
    card.querySelectorAll('form button[type="submit"]').forEach((button) => {
      const available = choice.dataset.cardAvailable === 'true' && Number(choice.dataset.cardPriceRaw) > 0;
      button.disabled = !available;
      const label = button.querySelector('[data-card-cart-label]') || button;
      label.textContent = Number(choice.dataset.cardPriceRaw) <= 0 ? 'Fiyat için yazın' : available ? 'Sepete ekle' : 'Tükendi';
      button.setAttribute('aria-label', (card.querySelector('[data-card-title-link]')?.textContent.trim() || '') + ' — ' + label.textContent);
    });
    const price = card.querySelector('.catalog-card__price');
    if (price) {
      price.replaceChildren();
      const strong = document.createElement('strong');
      strong.textContent = choice.dataset.cardPriceRaw === '0' ? 'Fiyat için yazın' : choice.dataset.cardPrice || '';
      price.append(strong);
      if (choice.dataset.cardCompare) {
        const compare = document.createElement('s');
        compare.textContent = choice.dataset.cardCompare;
        price.append(compare);
      }
    }
    const media = card.querySelector('.catalog-card__media');
    const primary = media?.querySelector('img:not(.catalog-card__alt)');
    let alternate = media?.querySelector('.catalog-card__alt');
    const unavailableMedia = media?.querySelector('.card-media-unavailable');
    if (unavailableMedia) unavailableMedia.hidden = Boolean(choice.dataset.cardImage);
    const hoverSource = choice.dataset.cardHoverImage;
    const hasHover = Boolean(choice.dataset.cardImage && hoverSource && hoverSource !== choice.dataset.cardImage);
    if (hasHover && media) {
      if (!alternate) {
        alternate = document.createElement('img');
        alternate.className = 'catalog-card__alt';
        alternate.alt = '';
        alternate.loading = 'lazy';
        media.append(alternate);
      }
      alternate.src = hoverSource;
      alternate.srcset = '';
      alternate.hidden = false;
    } else if (alternate) {
      alternate.hidden = true;
    }
    if (media) media.classList.toggle('card-hover-disabled', !hasHover);
    if (primary && choice.dataset.cardImage) {
      primary.hidden = false;
      primary.src = choice.dataset.cardImage;
      primary.srcset = choice.dataset.cardSrcset || '';
      primary.alt = choice.dataset.cardAlt || '';
    } else if (primary) {
      primary.hidden = true;
    }
  };
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-card-variant]');
    if (!choice) return;
    event.preventDefault();
    event.stopPropagation();
    selectCardVariant(choice);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const choice = event.target.closest('[data-card-variant]');
    if (!choice) return;
    event.preventDefault();
    selectCardVariant(choice);
  });
  const cardFavoriteKey = 'sumen-home-favorites-v1';
  const savedCardFavorites = () => {
    try { const values = JSON.parse(localStorage.getItem(cardFavoriteKey) || '[]'); return new Set(Array.isArray(values) ? values.filter(v => typeof v === 'string') : []); }
    catch { return new Set(); }
  };
  const syncCardFavorites = () => {
    const saved = savedCardFavorites();
    document.querySelectorAll('[data-card-favorite]').forEach(button => {
      const selected = saved.has(button.dataset.cardFavorite);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? 'Favorilerden kaldır: ' : 'Favorilere ekle: ') + button.dataset.cardFavoriteTitle);
    });
  };
  syncCardFavorites();
  let favoriteSyncPending = false;
  new MutationObserver(records => {
    if (favoriteSyncPending || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-card-favorite], [data-reference-card]') || node.querySelector?.('[data-card-favorite]'))))) return;
    favoriteSyncPending = true;
    queueMicrotask(() => { favoriteSyncPending = false; syncCardFavorites(); });
  }).observe(document.body, {childList:true, subtree:true});
  window.addEventListener('storage', event => { if (event.key === cardFavoriteKey) syncCardFavorites(); });
  document.addEventListener('click', event => {
    const favorite = event.target.closest('[data-card-favorite]');
    if (favorite) {
      const saved = savedCardFavorites();
      const key = favorite.dataset.cardFavorite;
      if (saved.has(key)) saved.delete(key); else saved.add(key);
      try { localStorage.setItem(cardFavoriteKey, JSON.stringify([...saved])); } catch {}
      const selected = saved.has(key);
      document.querySelectorAll('[data-card-favorite]').forEach(button => {
        if (button.dataset.cardFavorite !== key) return;
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', (selected ? 'Favorilerden kaldır: ' : 'Favorilere ekle: ') + button.dataset.cardFavoriteTitle);
      });
      return;
    }
    const toggle = event.target.closest('[data-card-colors-toggle]');
    const next = event.target.closest('[data-card-colors-next]');
    if (!toggle && !next) return;
    const colors = (toggle || next).closest('.catalog-card__colors');
    const swatches = colors.querySelector('.catalog-card__swatches');
    if (toggle) {
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      colors.toggleAttribute('data-colors-expanded', expanded);
    } else {
      const max = swatches.scrollWidth - swatches.clientWidth;
      swatches.scrollTo({left: swatches.scrollLeft >= max - 2 ? 0 : Math.min(max, swatches.scrollLeft + swatches.clientWidth * .8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
  // Search forms submit directly to Shopify's native results page.
  document.querySelectorAll('.product-page').forEach((root) => {
    const select = root.querySelector('select[name="id"]');
    const cards = root.querySelectorAll('[data-visual-variant]');
    if (!select || !cards.length) return;
    const colorPicker = root.querySelector('.product-variant-colors');
    const colorIndex = colorPicker ? Number(colorPicker.dataset.colorOptionIndex) : -1;
    const data = root.parentElement.querySelector('[data-product-variants]');
    let variants = [];
    try { variants = JSON.parse(data?.textContent || '[]'); } catch {}
    const syncCards = () => {
      const current = variants.find((variant) => String(variant.id) === select.value);
      cards.forEach((card) => {
        if (current && card.dataset.colorValue && colorIndex >= 0 && current.options.length > 1) {
          const matching = variants.find((variant) => variant.options[colorIndex] === card.dataset.colorValue
            && variant.options.every((value, index) => index === colorIndex || value === current.options[index]));
          if (matching) {
            const url = new URL(location.href);
            url.searchParams.set('variant', matching.id);
            url.hash = '';
            card.href = url.pathname + url.search;
            card.dataset.visualVariant = String(matching.id);
            card.setAttribute('aria-disabled', String(!matching.available));
            delete card.dataset.missingCombination;
          } else {
            card.removeAttribute('href');
            card.setAttribute('aria-disabled', 'true');
            card.dataset.missingCombination = 'true';
          }
        }
        if (card.dataset.visualVariant === select.value) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
    };
    cards.forEach((card) => card.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (card.dataset.missingCombination === 'true') return;
      select.value = card.dataset.visualVariant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      syncCards();
    }));
    select.addEventListener('change', syncCards);
    syncCards();
  });

  document.querySelectorAll('.product-page').forEach((root) => {
    const picker = root.querySelector('[data-compact-options]');
    const native = root.querySelector('select[name="id"]');
    const data = root.parentElement.querySelector('[data-product-variants]');
    if (!picker || !native || !data) return;
    const variants = JSON.parse(data.textContent);
    const inputs = [...picker.querySelectorAll('[data-option-index]')];
    const sync = () => {
      const current = variants.find(v => String(v.id) === native.value);
      if (!current) return;
      inputs.forEach((input, index) => {
        input.value = current.options[index];
        [...input.options].forEach(option => {
          option.disabled = !variants.some(v => v.options[index] === option.value && inputs.slice(0, index).every((prior, i) => v.options[i] === prior.value));
        });
      });
    };
    inputs.forEach((input, index) => input.addEventListener('change', () => {
      const values = inputs.map(item => item.value);
      const matches = variants.filter(v => values.slice(0, index + 1).every((value, i) => v.options[i] === value));
      const next = matches.find(v => v.options.every((value, i) => value === values[i])) || matches.find(v => v.available) || matches[0];
      if (!next) { sync(); return; }
      native.value = String(next.id);
      native.dispatchEvent(new Event('change', {bubbles: true}));
      sync();
    }));
    native.addEventListener('change', sync);
    sync();
  });

  const rail = document.querySelector('[data-product-rail]');
  const filterButtons = [...document.querySelectorAll('.product-filters .filter-button')];
  const emptyState = document.querySelector('[data-empty-state]');

  const applyFilter = (filter) => {
    let visibleCount = 0;
    rail?.querySelectorAll('.product-card').forEach((card) => {
      const visible = filter === 'all'
        || card.dataset.type === filter
        || (filter === 'personalizable' && card.dataset.personalizable === 'true');
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    filterButtons.forEach((button) => {
      const active = button.dataset.filter === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    if (emptyState) emptyState.hidden = visibleCount > 0;
  };

  filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter || 'all')));

  const consentKey = 'sumen-tr-consent-v1';
  const cookieBanner = document.querySelector('.cookie-banner');
  const cookieDialog = document.querySelector('.cookie-dialog');
  const analyticsConsent = document.querySelector('.analytics-consent');

  const readConsent = () => {
    try { return JSON.parse(localStorage.getItem(consentKey)); } catch { return null; }
  };

  const applyShopifyConsent = (analytics) => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(Boolean(analytics), () => {});
    }
  };

  const writeConsent = (analytics) => {
    const value = { necessary: true, analytics: Boolean(analytics), updatedAt: new Date().toISOString() };
    try { localStorage.setItem(consentKey, JSON.stringify(value)); } catch { /* Consent remains session-only. */ }
    applyShopifyConsent(value.analytics);
    if (cookieBanner) cookieBanner.hidden = true;
    closeDialog(cookieDialog);
  };

  const openConsentSettings = () => {
    const current = readConsent();
    if (analyticsConsent) analyticsConsent.checked = Boolean(current?.analytics);
    cookieDialog?.showModal();
  };

  document.querySelector('.cookie-reject')?.addEventListener('click', () => writeConsent(false));
  document.querySelector('.cookie-accept')?.addEventListener('click', () => writeConsent(true));
  document.querySelector('.cookie-save')?.addEventListener('click', () => writeConsent(analyticsConsent?.checked));
  document.querySelector('.cookie-customize')?.addEventListener('click', openConsentSettings);
  document.querySelector('.cookie-settings-trigger')?.addEventListener('click', openConsentSettings);

  const consent = readConsent();
  if (consent) applyShopifyConsent(consent.analytics);
  else if (cookieBanner) cookieBanner.hidden = false;

  const gallery = document.querySelector("[data-product-gallery]");
  const galleryStage = gallery?.querySelector("[data-gallery-stage]");
  const galleryZoom = document.querySelector("[data-gallery-zoom]");
  const galleryZoomImg = galleryZoom?.querySelector("[data-gallery-zoom-img]");
  const thumbs = [...document.querySelectorAll(".product-page [data-gallery-thumb]")];
  const galleryByColor = Boolean(document.querySelector(".product-page .product-gallery__thumbs")?.hasAttribute("data-gallery-by-color"));
  const shown = () => thumbs.filter((el) => !el.hidden);
  const zoomViewport = galleryZoom?.querySelector("[data-zoom-viewport]");
  const zoomToggle = galleryZoom?.querySelector("[data-zoom-toggle]");
  let imageIndex = Math.max(0, shown().findIndex((el) => el.classList.contains("is-active")));
  let scale = 1;
  let tx = 0;
  let ty = 0;
  let dragging = false;
  let moved = false;
  let startX = 0;
  let startY = 0;
  let startTx = 0;
  let startTy = 0;
  const ZOOM_SCALE = 2.4;

  const applyPan = () => {
    if (!galleryZoomImg) return;
    galleryZoomImg.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
  };

  const clampPan = () => {
    if (!zoomViewport || !galleryZoomImg) return;
    const vw = zoomViewport.clientWidth;
    const vh = zoomViewport.clientHeight;
    const nw = galleryZoomImg.naturalWidth || 1;
    const nh = galleryZoomImg.naturalHeight || 1;
    const fit = Math.min(vw / nw, vh / nh);
    const dispW = nw * fit * scale;
    const dispH = nh * fit * scale;
    const maxX = Math.max(0, (dispW - vw) / 2);
    const maxY = Math.max(0, (dispH - vh) / 2);
    tx = Math.min(maxX, Math.max(-maxX, tx));
    ty = Math.min(maxY, Math.max(-maxY, ty));
  };

  const setZoomed = (on) => {
    scale = on ? ZOOM_SCALE : 1;
    if (!on) {
      tx = 0;
      ty = 0;
    }
    zoomViewport?.classList.toggle("is-zoomed", on);
    zoomToggle?.setAttribute("aria-pressed", String(on));
    if (zoomToggle) zoomToggle.textContent = on ? "Sığdır" : "Yakınlaştır";
    clampPan();
    applyPan();
  };

  const resetZoom = () => setZoomed(false);

  const updateZoom = () => {
    if (!galleryZoomImg || !galleryStage) return;
    galleryZoomImg.style.transition = "none";
    galleryZoomImg.src = galleryStage.getAttribute("data-full") || "";
    galleryZoomImg.alt = galleryStage.querySelector("img")?.alt || "";
    const count = galleryZoom.querySelector("[data-zoom-count]");
    if (count) count.textContent = imageIndex + 1 + " / " + Math.max(1, shown().length);
    resetZoom();
    requestAnimationFrame(() => {
      if (galleryZoomImg) galleryZoomImg.style.transition = "";
    });
  };

  const syncZoomNav = () => {
    const many = shown().length > 1;
    galleryZoom?.querySelectorAll("[data-zoom-prev],[data-zoom-next]").forEach((button) => {
      button.disabled = !many;
    });
  };

  const setGalleryImage = (thumb) => {
    const img = galleryStage?.querySelector("img");
    if (!img || !thumb) return;
    imageIndex = Math.max(0, shown().indexOf(thumb));
    img.src = thumb.getAttribute("data-src") || img.src;
    const srcset = thumb.getAttribute("data-srcset");
    if (srcset) img.srcset = srcset;
    img.alt = thumb.getAttribute("data-alt") || img.alt;
    galleryStage.setAttribute("data-full", thumb.getAttribute("data-full") || "");
    thumbs.forEach((el) => {
      const active = el === thumb;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-pressed", String(active));
    });
    syncZoomNav();
    if (galleryZoom?.open) updateZoom();
  };

  const applyGalleryGroup = () => {
    if (!galleryByColor) {
      syncZoomNav();
      return;
    }
    const field = document.querySelector('form.product-form [name="id"]');
    const variantId = field?.value || "";
    if (!variantId) {
      syncZoomNav();
      return;
    }
    const token = "|" + variantId + "|";
    thumbs.forEach((el) => {
      const owners = "|" + (el.getAttribute("data-gallery-variants") || "");
      el.hidden = owners.indexOf(token) === -1;
    });
    let featuredId = "";
    try {
      const list = JSON.parse(document.querySelector("[data-product-variants]")?.textContent || "[]");
      const current = list.find((item) => String(item.id) === variantId);
      if (current && current.imageId != null) featuredId = String(current.imageId);
    } catch { /* İlk görünür görsel kalır. */ }
    let visible = shown();
    if (!visible.length) {
      thumbs.forEach((el) => { el.hidden = false; });
      visible = shown();
    }
    const next = visible.find((el) => el.getAttribute("data-image-id") === featuredId) || visible[0];
    if (next && !next.classList.contains("is-active")) setGalleryImage(next);
    else if (next) {
      imageIndex = Math.max(0, visible.indexOf(next));
      syncZoomNav();
    } else syncZoomNav();
  };

  const selectVariantFromThumb = (thumb) => {
    if (!thumb.closest("[data-image-picks-variant]")) return;
    const select = document.querySelector('.product-page select[name="id"]');
    const node = document.querySelector("[data-product-variants]");
    if (!select || !node) return;
    let variants = [];
    try { variants = JSON.parse(node.textContent || "[]"); } catch { return; }
    const match = variants.find((variant) => String(variant.imageId) === String(thumb.getAttribute("data-image-id")));
    if (!match || String(select.value) === String(match.id)) return;
    select.value = String(match.id);
    select.dispatchEvent(new Event("change", { bubbles: true }));
  };

  thumbs.forEach((thumb) => thumb.addEventListener("click", () => {
    if (thumb.hidden) return;
    setGalleryImage(thumb);
    selectVariantFromThumb(thumb);
  }));
  galleryStage?.addEventListener("click", () => {
    if (!galleryZoom || !galleryZoomImg || !galleryStage.getAttribute("data-full")) return;
    updateZoom();
    galleryZoom.showModal();
  });

  const moveImage = (delta) => {
    const visible = shown();
    if (visible.length > 1) setGalleryImage(visible[(imageIndex + delta + visible.length) % visible.length]);
  };

  galleryZoom?.querySelectorAll("[data-zoom-prev]").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      moveImage(-1);
    });
  });
  galleryZoom?.querySelectorAll("[data-zoom-next]").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.stopPropagation();
      moveImage(1);
    });
  });
  syncZoomNav();

  const toggleZoom = () => setZoomed(!(scale > 1.01));
  zoomToggle?.addEventListener("click", (event) => {
    event.stopPropagation();
    toggleZoom();
  });

  galleryZoomImg?.addEventListener("load", () => {
    clampPan();
    applyPan();
  });

  const SWIPE_MIN = 48;
  let swipeDx = 0;
  let swipeDy = 0;

  const releasePointer = (event) => {
    if (!zoomViewport.hasPointerCapture(event.pointerId)) return false;
    zoomViewport.releasePointerCapture(event.pointerId);
    zoomViewport.classList.remove("is-dragging", "is-panning");
    return true;
  };

  zoomViewport?.addEventListener("pointerdown", (event) => {
    if (event.button !== 0 || event.target.closest("button")) return;
    event.preventDefault();
    dragging = scale > 1.01;
    moved = false;
    swipeDx = 0;
    swipeDy = 0;
    startX = event.clientX;
    startY = event.clientY;
    startTx = tx;
    startTy = ty;
    zoomViewport.setPointerCapture(event.pointerId);
    zoomViewport.classList.add("is-dragging");
    if (dragging) zoomViewport.classList.add("is-panning");
  });
  zoomViewport?.addEventListener("pointermove", (event) => {
    if (!zoomViewport.hasPointerCapture(event.pointerId)) return;
    swipeDx = event.clientX - startX;
    swipeDy = event.clientY - startY;
    if (Math.hypot(swipeDx, swipeDy) > 4) moved = true;
    if (dragging) {
      tx = startTx + swipeDx;
      ty = startTy + swipeDy;
      clampPan();
      applyPan();
      return;
    }
    if (shown().length > 1 && galleryZoomImg) {
      galleryZoomImg.style.transform = "translate(" + swipeDx + "px,0) scale(1)";
    }
  });
  zoomViewport?.addEventListener("pointerup", (event) => {
    if (!releasePointer(event)) return;
    const horizontal = Math.abs(swipeDx) >= SWIPE_MIN && Math.abs(swipeDx) > Math.abs(swipeDy);
    if (!dragging && shown().length > 1 && horizontal) moveImage(swipeDx < 0 ? 1 : -1);
    else if (!moved) toggleZoom();
    else applyPan();
    dragging = false;
  });
  zoomViewport?.addEventListener("pointercancel", (event) => {
    if (!releasePointer(event)) return;
    applyPan();
    dragging = false;
  });
  zoomViewport?.addEventListener("wheel", (event) => {
    event.preventDefault();
    if (event.deltaY < 0) setZoomed(true);
    else if (scale > 1.01) setZoomed(false);
  }, { passive: false });

  galleryZoom?.addEventListener("keydown", (event) => {
    if (event.key === "ArrowRight") {
      event.preventDefault();
      moveImage(1);
    }
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      moveImage(-1);
    }
  });
  galleryZoom?.addEventListener("close", () => {
    resetZoom();
    galleryStage?.focus({ preventScroll: true });
  });
  const atcButton=document.querySelector('[data-add-to-cart]');
  const stickyAtc=document.querySelector('[data-sticky-atc]');
  const stickySubmit=document.querySelector('[data-sticky-submit]');
  const syncSticky=()=>{if(!atcButton||!stickyAtc)return;const rect=atcButton.getBoundingClientRect();stickyAtc.hidden=rect.bottom>0&&rect.top<window.innerHeight;if(stickySubmit){stickySubmit.disabled=atcButton.disabled;stickySubmit.textContent=atcButton.textContent.trim();}};
  if(atcButton&&stickyAtc){if('IntersectionObserver' in window)new IntersectionObserver(syncSticky,{threshold:0}).observe(atcButton);new MutationObserver(syncSticky).observe(atcButton,{attributes:true,attributeFilter:['disabled'],childList:true,subtree:true});let stickyFrame=0;window.addEventListener('scroll',()=>{if(stickyFrame)return;stickyFrame=requestAnimationFrame(()=>{stickyFrame=0;syncSticky();});},{passive:true});window.addEventListener('resize',syncSticky,{passive:true});syncSticky();}
  stickySubmit?.addEventListener('click',()=>{if(!atcButton||atcButton.disabled)return;const form=atcButton.closest('form');form?.requestSubmit(atcButton);});
  const variantSelect=document.querySelector('form.product-form select[name="id"]');
  const variantsEl=document.querySelector('[data-product-variants]');
  let variants=[];try{variants=JSON.parse(variantsEl?.textContent||'[]');}catch{}
  let restoringVariant = false;
  variantSelect?.addEventListener('change',()=>{
    const v=variants.find(v=>String(v.id)===variantSelect.value);if(!v)return;
    const colorPicker=document.querySelector('.product-page .product-variant-colors');
    const colorIndex=Number(colorPicker?.getAttribute('data-color-option-index'));
    const currentColor=colorPicker?.querySelector('[data-current-color]');
    if(currentColor&&Number.isInteger(colorIndex))currentColor.textContent=v.options[colorIndex]||'';
    const price=document.querySelector('[data-product-price]');if(price){price.replaceChildren();const strong=document.createElement('strong');strong.textContent=v.price;price.append(strong);if(v.compare){const old=document.createElement('s');old.textContent=v.compare;price.append(old);}}
    const stickyPrice=document.querySelector('[data-sticky-price]');if(stickyPrice)stickyPrice.textContent=v.price;
    if(atcButton){atcButton.disabled=!v.available;atcButton.textContent=v.available?'Sepete ekle':'Tükendi';}
    const sku=document.querySelector('.product-sku');if(sku)sku.textContent=v.sku?'Ürün kodu: '+v.sku:'';
    if(galleryByColor)applyGalleryGroup();
    else{const thumb=thumbs.find(el=>el.getAttribute('data-image-id')===String(v.imageId));if(thumb)setGalleryImage(thumb);}
    if (!restoringVariant) {
      const url=new URL(location.href);
      url.searchParams.set('variant',v.id);
      url.hash='';
      if (url.href !== location.href) history.pushState(history.state,'',url);
    }
    syncSticky();
  });
  applyGalleryGroup();
  const legacyVariantIds = {
    "duvara-monte-kumasli-pano": {
      "56290712158500": "67797376893220",
      "56290712191268": "67797376925988",
      "56290712224036": "67797376958756",
      "56290712256804": "67797376991524",
      "56290712289572": "67797377024292",
      "56290712322340": "67797377057060",
      "56290712355108": "67797377089828",
      "56290712387876": "67797377122596",
      "56290712420644": "67797377155364",
      "56290712453412": "67797377188132",
      "56290712486180": "67797377220900",
      "56290711765284": "67797377253668",
      "56290711798052": "67797377286436",
      "56290711830820": "67797377319204",
      "56290711863588": "67797377351972",
      "56290711896356": "67797377384740",
      "56290711929124": "67797377417508",
      "56290711961892": "67797377450276",
      "56290711994660": "67797377483044",
      "56290712027428": "67797377515812",
      "56290712060196": "67797377548580",
      "56290712092964": "67797377581348",
      "56290711339300": "67797377614116",
      "56290711372068": "67797377646884",
      "56290711404836": "67797377679652",
      "56290711437604": "67797377712420",
      "56290711470372": "67797377745188",
      "56290711503140": "67797377777956",
      "56290711535908": "67797377810724",
      "56290711568676": "67797377843492",
      "56290711601444": "67797377876260",
      "56290711634212": "67797377909028",
      "56290711666980": "67797377941796"
    },
    "15386374373668": {
      "67759226061092": "67797386461476",
      "67759226093860": "67797386494244",
      "67759226126628": "67797386527012",
      "67759226159396": "67797386559780",
      "67759226192164": "67797386592548",
      "67759226224932": "67797386625316",
      "67759226257700": "67797386658084",
      "67759226290468": "67797386690852",
      "67759226323236": "67797386723620",
      "67759226356004": "67797386756388",
      "67759226388772": "67797386789156",
      "67759226421540": "67797386821924",
      "67759226454308": "67797386854692",
      "67759226487076": "67797386887460"
    },
    "cift-katli-evrak-rafi-masa-organizeri-dosya-duzenleyici": {
      "56235068326180": "56235047977252",
      "56235068358948": "56235048173860",
      "56235068391716": "56235048141092",
      "56235068424484": "56235048108324",
      "56235068457252": "56235048075556",
      "56235068490020": "56235048042788",
      "56235068522788": "56235048010020",
      "56235068555556": "56235047944484",
      "56235068588324": "56235047878948",
      "56235068621092": "56235047911716",
      "56235068686628": "56235048173860",
      "56235068719396": "56235048141092",
      "56235068752164": "56235048108324",
      "56235068784932": "56235048075556",
      "56235068817700": "56235048042788",
      "56235068850468": "56235048010020",
      "56235068883236": "56235047944484",
      "56235068916004": "56235047878948",
      "56235068948772": "56235047911716",
      "56235068981540": "56235047977252",
      "56235069112612": "56235048141092",
      "56235069145380": "56235048108324",
      "56235069178148": "56235048075556",
      "56235069210916": "56235048042788",
      "56235069243684": "56235048010020",
      "56235069276452": "56235047944484",
      "56235069309220": "56235047878948",
      "56235069341988": "56235047911716",
      "56235069374756": "56235047977252",
      "56235069407524": "56235048173860",
      "56235069440292": "56235048108324",
      "56235069473060": "56235048075556",
      "56235069505828": "56235048042788",
      "56235069538596": "56235048010020",
      "56235069571364": "56235047944484",
      "56235069604132": "56235047878948",
      "56235069636900": "56235047911716",
      "56235069669668": "56235047977252",
      "56235069702436": "56235048141092",
      "56235069735204": "56235048173860",
      "56235069767972": "56235048075556",
      "56235069800740": "56235048042788",
      "56235069833508": "56235048010020",
      "56235069866276": "56235047944484",
      "56235069899044": "56235047878948",
      "56235069931812": "56235047911716",
      "56235069964580": "56235047977252",
      "56235069997348": "56235048108324",
      "56235070030116": "56235048141092",
      "56235070062884": "56235048173860",
      "56235070128420": "56235048042788",
      "56235070161188": "56235048010020",
      "56235070193956": "56235047944484",
      "56235070226724": "56235047878948",
      "56235070259492": "56235047911716",
      "56235070292260": "56235047977252",
      "56235070325028": "56235048075556",
      "56235070357796": "56235048108324",
      "56235070390564": "56235048141092",
      "56235070423332": "56235048173860",
      "56235070456100": "56235048010020",
      "56235070488868": "56235047944484",
      "56235070521636": "56235047878948",
      "56235070554404": "56235047911716",
      "56235070587172": "56235047977252",
      "56235070619940": "56235048042788",
      "56235070652708": "56235048075556",
      "56235070685476": "56235048108324",
      "56235070718244": "56235048141092",
      "56235070751012": "56235048173860",
      "56235070783780": "56235047944484",
      "56235070816548": "56235047878948",
      "56235070849316": "56235047911716",
      "56235070882084": "56235047977252",
      "56235070914852": "56235048010020",
      "56235070947620": "56235048042788",
      "56235070980388": "56235048075556",
      "56235071013156": "56235048108324",
      "56235071045924": "56235048141092",
      "56235071078692": "56235048173860",
      "56235071111460": "56235047911716",
      "56235071144228": "56235047878948",
      "56235071176996": "56235047944484",
      "56235071209764": "56235047977252",
      "56235071242532": "56235048010020",
      "56235071275300": "56235048042788",
      "56235071308068": "56235048075556",
      "56235071340836": "56235048108324",
      "56235071373604": "56235048141092",
      "56235071406372": "56235048173860"
    }
  };
  const restoreVariant = () => {
    if (!variantSelect) return;
    const url = new URL(location.href);
    const legacyId = url.hash.match(/^#variant=(\d+)$/)?.[1];
    const requestedId = url.searchParams.get('variant') || legacyId;
    if (!requestedId) return;
    const handle = url.pathname.match(/^\/products\/([^/]+)\/?$/)?.[1];
    const productId = document.querySelector('.product-page[data-product-id]')?.dataset.productId;
    const id = variants.some((item) => String(item.id) === requestedId)
      ? requestedId
      : legacyVariantIds[productId]?.[requestedId]
        || legacyVariantIds[handle]?.[requestedId]
        || (legacyId && variants.some((item) => String(item.id) === legacyId) ? legacyId : variantSelect.value);
    if (!id || !variants.some((item) => String(item.id) === id)) return;
    if (legacyId || id !== requestedId) {
      url.searchParams.set('variant', id);
      url.hash = '';
      history.replaceState(history.state, '', url);
    }
    if (variantSelect.value === id) return;
    restoringVariant = true;
    variantSelect.value = id;
    variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
    restoringVariant = false;
  };
  window.addEventListener('popstate', restoreVariant);
  restoreVariant();

  const searchInput = document.querySelector('#site-search');
  const suggestList = document.querySelector('[data-search-suggest]');
  const searchStatus = document.querySelector('[data-search-status]');
  const searchShortcuts = document.querySelector('[data-search-shortcuts]');
  let suggestTimer = 0;
  let suggestAbort = null;
  let suggestSeq = 0;
  const resetSuggest = (message) => {
    if (suggestList) {
      suggestList.hidden = true;
      suggestList.replaceChildren();
    }
    if (searchShortcuts) searchShortcuts.hidden = false;
    if (searchStatus) searchStatus.textContent = message;
  };
  const renderSuggest = (products) => {
    if (!suggestList) return;
    suggestList.replaceChildren();
    if (!products.length) {
      resetSuggest('Eşleşen ürün bulunamadı. Koleksiyonlardan devam edebilirsiniz.');
      return;
    }
    if (searchShortcuts) searchShortcuts.hidden = true;
    products.forEach((product) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'search-suggest__item';
      link.href = product.url;
      const imageUrl = product.featured_image?.url || product.image;
      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl.indexOf('//') === 0 ? 'https:' + imageUrl : imageUrl;
        img.alt = '';
        link.append(img);
      }
      const text = document.createElement('span');
      text.textContent = product.title;
      link.append(text);
      item.append(link);
      suggestList.append(item);
    });
    suggestList.hidden = false;
    if (searchStatus) searchStatus.textContent = products.length + ' öneri';
  };
  searchInput?.addEventListener('input', () => {
    const query = searchInput.value.trim();
    window.clearTimeout(suggestTimer);
    if (suggestAbort) suggestAbort.abort();
    if (query.length < 2) {
      resetSuggest('Mağazadaki ürünler içinde arayın.');
      return;
    }
    suggestTimer = window.setTimeout(async () => {
      const seq = ++suggestSeq;
      suggestAbort = new AbortController();
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6';
        const response = await fetch(url, { signal: suggestAbort.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('suggest');
        const data = await response.json();
        if (seq !== suggestSeq) return;
        renderSuggest(data.resources?.results?.products || []);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (searchStatus) searchStatus.textContent = 'Öneriler yüklenemedi. Enter ile aramayı tamamlayın.';
      }
    }, 280);
  });
  searchDialog?.addEventListener('close', () => {
    window.clearTimeout(suggestTimer);
    if (suggestAbort) suggestAbort.abort();
  });

  const cartDrawer = document.querySelector('#CartDrawer');
  const moneyFormat = cartDrawer?.getAttribute('data-money-format') || '{{amount}}';
  const cartLines = cartDrawer?.querySelector('[data-cart-lines]');
  const cartEmpty = cartDrawer?.querySelector('[data-cart-empty]');
  const cartEmptyLinks = cartDrawer?.querySelector('[data-cart-empty-links]');
  const cartFoot = cartDrawer?.querySelector('[data-cart-drawer-foot]');
  const cartSubtotal = cartDrawer?.querySelector('[data-cart-subtotal]');
  const cartPersonalizedReturn = cartDrawer?.querySelector('[data-personalized-return]');
  const cartStatus = document.querySelector('[data-cart-status]');
  const formatMoney = (cents) => {
    const number = Number(cents);
    if (!Number.isFinite(number)) return '';
    const negative = number < 0;
    const abs = Math.abs(number) / 100;
    const parts = abs.toFixed(2).split('.');
    const groupedDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const groupedComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let output = moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, groupedDot + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, groupedDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, groupedComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/g, groupedComma + '.' + parts[1]);
    if (negative) output = '-' + output;
    return output;
  };
  const setCartStatus = (message, isError) => {
    if (!cartStatus) return;
    if (!message) {
      cartStatus.hidden = true;
      cartStatus.textContent = '';
      return;
    }
    cartStatus.hidden = false;
    cartStatus.textContent = message;
    cartStatus.style.color = isError ? '#7a2e24' : 'var(--muted)';
  };
  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  };
  const renderCart = (cart) => {
    if (!cartDrawer) return;
    updateCartCount(cart.item_count);
    const empty = !cart.item_count;
    if (cartEmpty) cartEmpty.hidden = !empty;
    if (cartEmptyLinks) cartEmptyLinks.hidden = !empty;
    if (cartLines) cartLines.hidden = empty;
    if (cartFoot) cartFoot.hidden = empty;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    const hasPersonalized = (cart.items || []).some((item) => item.properties && (String(item.properties['İsim'] || '').trim() || String(item.properties['Ünvan'] || '').trim()));
    if (cartPersonalizedReturn) cartPersonalizedReturn.hidden = !hasPersonalized;
    if (!cartLines) return;
    cartLines.replaceChildren();
    (cart.items || []).forEach((item) => {
      const article = document.createElement('article');
      article.className = 'cart-drawer__line';
      const imageLink = document.createElement('a');
      imageLink.href = item.url;
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.product_title || item.title || '';
        imageLink.append(img);
      }
      const body = document.createElement('div');
      const title = document.createElement('a');
      title.href = item.url;
      title.innerHTML = '<strong></strong>';
      title.querySelector('strong').textContent = item.product_title || item.title || '';
      body.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.textContent = item.variant_title;
        body.append(variant);
      }
      if (item.properties) {
        Object.keys(item.properties).forEach((key) => {
          if (!key || key.charAt(0) === '_' || !item.properties[key]) return;
          const prop = document.createElement('p');
          prop.textContent = key + ': ' + item.properties[key];
          body.append(prop);
        });
      }
      const price = document.createElement('p');
      price.textContent = formatMoney(item.final_line_price);
      body.append(price);
      const qty = document.createElement('div');
      qty.className = 'cart-drawer__qty';
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'Adeti azalt');
      minus.textContent = '−';
      minus.addEventListener('click', () => changeCart(item.key, item.quantity - 1));
      const count = document.createElement('span');
      count.textContent = String(item.quantity);
      const plus = document.createElement('button');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'Adeti artır');
      plus.textContent = '+';
      plus.addEventListener('click', () => changeCart(item.key, item.quantity + 1));
      qty.append(minus, count, plus);
      body.append(qty);
      article.append(imageLink, body);
      cartLines.append(article);
    });
  };
  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };
  const openCartDrawer = async () => {
    if (!cartDrawer) return;
    try {
      renderCart(await fetchCart());
    } catch {
      window.location.href = '/cart';
      return;
    }
    if (!cartDrawer.open) cartDrawer.showModal();
  };
  const changeCart = async (key, quantity) => {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      if (!response.ok) throw new Error('change');
      renderCart(await response.json());
    } catch {
      window.location.href = '/cart';
    }
  };
  document.querySelectorAll('[data-cart-open]').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      closeDialog(mobileMenu);
      openCartDrawer();
    });
  });
  const faqRoot = document.querySelector('[data-faq-root]');
  const faqSearch = document.querySelector('[data-faq-search]');
  const faqStatus = document.querySelector('[data-faq-status]');
  if (faqRoot && faqSearch) {
    const items = [...faqRoot.querySelectorAll('.faq-item')];
    const sections = [...faqRoot.querySelectorAll('.faq-section')];
    const filterFaq = () => {
      const q = faqSearch.value.trim().toLocaleLowerCase('tr-TR');
      let visible = 0;
      items.forEach((item) => {
        const match = !q || item.textContent.toLocaleLowerCase('tr-TR').includes(q);
        item.classList.toggle('is-hidden', !match);
        if (match) visible += 1;
      });
      sections.forEach((section) => {
        const any = section.querySelector('.faq-item:not(.is-hidden)');
        section.classList.toggle('is-empty', Boolean(q) && !any);
      });
      if (faqStatus) faqStatus.hidden = visible !== 0;
    };
    faqSearch.addEventListener('input', filterFaq);
  }

  const moreGrid = document.querySelector('[data-more-grid]');
  const moreFeedEl = document.querySelector('[data-more-feed]');
  const moreBtn = document.querySelector('[data-more-load]');
  if (moreGrid && moreFeedEl?.content) {
    const feed = [...moreFeedEl.content.querySelectorAll('[data-card-product-id]')];
    const seen = new Set([...moreGrid.querySelectorAll('[data-card-product-id]')].map(card => card.dataset.cardProductId));
    let cursor = 0;
    const syncBtn = () => {
      if (moreBtn) moreBtn.hidden = !feed.slice(cursor).some(card => !seen.has(card.dataset.cardProductId));
    };
    moreBtn?.addEventListener('click', () => {
      let added = 0;
      while (cursor < feed.length && added < 4) {
        const card = feed[cursor++];
        if (seen.has(card.dataset.cardProductId)) continue;
        seen.add(card.dataset.cardProductId);
        moreGrid.append(card.cloneNode(true));
        added += 1;
      }
      syncBtn();
    });
    syncBtn();
  }

  document.querySelectorAll('form.product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (event.submitter && event.submitter.getAttribute('name') === 'checkout') return;
      event.preventDefault();
      const submit = form.querySelector('[data-add-to-cart]');
      if (submit?.disabled) return;
      const wasDisabled = Boolean(submit?.disabled);
      if (submit) submit.disabled = true;
      setCartStatus('Sepete ekleniyor…', false);
      let added = false;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok) {
          setCartStatus(data.description || data.message || 'Ürün sepete eklenemedi.', true);
          return;
        }
        added = true;
        setCartStatus('Sepete eklendi.', false);
        await openCartDrawer();
      } catch {
        setCartStatus(added ? 'Ürün sepete eklendi. Sepet simgesinden devam edebilirsiniz.' : 'Bağlantı kesildi. Tekrar eklemeden önce sepetinizi kontrol edin.', !added);
      } finally {
        if (submit) submit.disabled = wasDisabled;
      }
    });
  });

})();


